import {
	EM_DASH,
	formatNumber,
	formatEtDateTime,
	minutesSince,
} from 'pages/_rd_dashboard/QueueMonitor/components/queueMonitorFormat';

/**
 * Shared formatting helpers for the Dataset Monitor components.
 *
 * EM_DASH, formatNumber and formatEtDateTime are the existing Queue Monitor
 * v1 formatters (queueMonitorFormat.js) - re-exported here rather than
 * duplicated, per the Dataset Monitor design (spec 12). Only relativeAge()
 * below is new.
 */
export { EM_DASH, formatNumber, formatEtDateTime };

const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;

/**
 * Coarse relative age for a UTC ISO instant, e.g. "22m ago" / "3h ago" /
 * "5d ago"; an em dash for a null or invalid timestamp. Built on the
 * existing minutesSince() helper so the date-parsing and now-clamping
 * rules (a slightly-future server timestamp never renders "-1 min ago")
 * stay defined in exactly one place.
 */
export const relativeAge = (iso, now = new Date()) => {
	const minutes = minutesSince(iso, now);
	if (minutes === null) {
		return EM_DASH;
	}
	if (minutes < MINUTES_PER_HOUR) {
		return `${minutes}m ago`;
	}
	const hours = Math.floor(minutes / MINUTES_PER_HOUR);
	if (hours < HOURS_PER_DAY) {
		return `${hours}h ago`;
	}
	const days = Math.floor(hours / HOURS_PER_DAY);
	return `${days}d ago`;
};
